import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface Response {
  total_active_cards?: number | null;
  total_pending_activation_cards?: number | null;
}
const QUERY_KEY = 'CARD_STATUS_BRIEF_QUERY';
const useCardStatusBriefQuery = () => {
  // TODO: type is missing
  const { data, isLoading } = useQuery(
    [QUERY_KEY],
    () => api.get<Response>(API_URL.REPORTS_CARD_STATUS_REPORT_BRIEF),
    {
      cacheTime: 0,
    }
  );
  const formattedData = useMemo(() => {
    const response = data?.data;
    const active = response?.total_active_cards;

    const pending = response?.total_pending_activation_cards;
    return {
      active: !!active || active === 0 ? `${active}` : null,
      pending: !!pending || pending === 0 ? `${pending}` : null,
    };
  }, [data?.data]);
  return {
    isLoading,
    data: formattedData,
  };
};

export default useCardStatusBriefQuery;
